import React from "react";
import {
  LoadingState,
  ErrorState,
  NoResultsState,
  NoDataState,
} from "./EmptyStates";

// state calculation logic
const calculateStateFlags = (state) => {
  const isLoading = !state.learningActivities || state.loading;
  const isError = !!state.error;
  const hasCourses =
    !!state.learningActivities &&
    Array.isArray(state.learningActivities.allFilteredCourses) &&
    state.learningActivities.allFilteredCourses.length > 0;
  const noResults = !!state.hasActiveFilters && !hasCourses;
  const noData = !state.hasActiveFilters && !hasCourses;

  return { isLoading, isError, noResults, noData };
};

const StateRenderer = ({ state, languageContext, resetFilters }) => {
  const { isLoading, isError, noResults, noData } = calculateStateFlags(state);

  if (isLoading) {
    return <LoadingState languageContext={languageContext} />;
  }
  if (isError) {
    return <ErrorState languageContext={languageContext} />;
  }
  if (noResults) {
    return (
      <NoResultsState
        languageContext={languageContext}
        onClearFilters={() => resetFilters()}
      />
    );
  }
  if (noData) {
    return <NoDataState languageContext={languageContext} />;
  }
  return null;
};

export default StateRenderer;
